import { CommandResult } from "../../../Common/domain/src/api/commandResult";
import {
  RESEND_CODE,
  SetResendCodeState,
  RESEND_CODE_FAIL,
} from "../../domain/resendCode/index";

export const initialState: SetResendCodeState = {
  result: new CommandResult({ isValid: false }),
};
 
export default function resendCode(state = initialState, action: any) {
  switch (action.type) {
    case RESEND_CODE:
      return {
        ...state,
        result: action.payload,
      };
    case RESEND_CODE_FAIL:
      return { ...state, result: action.payload };
    default:
      return state;
  }
};
